// Allowed since this is the proxy
// eslint-disable-next-line no-restricted-imports
import { toAuthFetchers } from '@engage/data-fetch-v2/fetchers/auth';
import { toBrowseCategoryFetchers } from '@engage/data-fetch-v2/fetchers/browseCategory';
import { toClassFetchers } from '@engage/data-fetch-v2/fetchers/class';
import { toClassGroupsFetchers } from '@engage/data-fetch-v2/fetchers/classGroups';
import { toDigitalSubscriptionsFetchers } from '@engage/data-fetch-v2/fetchers/digitalSubscriptions';
import { toGuidanceFetchers } from '@engage/data-fetch-v2/fetchers/guidance';
import { toHomescreenFetchers } from '@engage/data-fetch-v2/fetchers/homescreen';
import { toMetadataFetchers } from '@engage/data-fetch-v2/fetchers/metadata';
import { toPartnershipFetchers } from '@engage/data-fetch-v2/fetchers/partnerships';
import { toPelotonFetchers } from '@engage/data-fetch-v2/fetchers/peloton';
import { toPostclassLeaderboardFetchers } from '@engage/data-fetch-v2/fetchers/postclassLeaderboard';
import { toPresenceFetchers } from '@engage/data-fetch-v2/fetchers/presence';
import { toRecommendationsFetchers } from '@engage/data-fetch-v2/fetchers/recommendations';
import { toSearchFetchers } from '@engage/data-fetch-v2/fetchers/search';
import { toStatsTokenFetchers } from '@engage/data-fetch-v2/fetchers/statsToken';
import { toStreamFetchers } from '@engage/data-fetch-v2/fetchers/stream';
import { toSubscriptionV2Fetchers } from '@engage/data-fetch-v2/fetchers/subscriptions';
import { toTooltipsFetchers } from '@engage/data-fetch-v2/fetchers/tooltips';
import { toUsersFetchers } from '@engage/data-fetch-v2/fetchers/users';
import { toWorkoutFetchers } from '@engage/data-fetch-v2/fetchers/workout';
import { toModerationFetchers } from './fetchers/moderation';
import { toProgressTrackingFetchers } from './fetchers/progressTracking';
import { toUserPreferencesFetchers } from './fetchers/userPreferences';
import { toActivityFeedFetchersGQL } from './graphql-fetchers/activityFeedFetchers';
import { toProgramsFetchersGQL } from './graphql-fetchers/programsFetchers';
import { toScheduledClassFetchersGQL } from './graphql-fetchers/scheduledClassFetchers';
import { toStackedClassesFetchersGQL } from './graphql-fetchers/stackedClassesFetchers';
import { toTagsFetchersGQL } from './graphql-fetchers/tagsFetchers';
import {
  engageApi,
  engageApiNoAuthHeader,
  engageApiTextResponseType,
  presenceApi,
  pagesApi,
  graphQlApi,
  tooltipsApi,
  guidanceApi,
  userPreferencesApi,
  progressTrackingApi,
} from './singletons';

export const AuthFetchers = toAuthFetchers(engageApi);
export const AuthFetchersNoAuthHeader = toAuthFetchers(engageApiNoAuthHeader);
export const ClassFetchers = toClassFetchers(engageApi);
export const ClassGroupsFetchers = toClassGroupsFetchers(engageApi);
export const DigitalSubscriptionsFetchers = toDigitalSubscriptionsFetchers(engageApi);
export const PelotonFetchers = toPelotonFetchers(engageApi);
export const PostclassLeaderboardFetchers = toPostclassLeaderboardFetchers(engageApi);
export const PresenceFetchers = toPresenceFetchers(presenceApi);
export const StatsTokenFetchers = toStatsTokenFetchers(engageApi);
export const StreamFetchers = toStreamFetchers(engageApi);
export const WorkoutsFetchers = toWorkoutFetchers(engageApi, 'web');
export const WorkoutsFetchersTextResponseType = toWorkoutFetchers(
  engageApiTextResponseType,
  'web',
);
export const UsersFetchers = toUsersFetchers(engageApi);
export const SearchFetchers = toSearchFetchers(engageApi);
export const BrowseCategoryFetchers = toBrowseCategoryFetchers(engageApi);
export const SubscriptionsFetchers = toSubscriptionV2Fetchers(engageApi);
export const MetadataFetchers = toMetadataFetchers(engageApi);
export const HomescreenFetchers = toHomescreenFetchers(pagesApi);
export const RecommendationFetchers = toRecommendationsFetchers(engageApi);
export const TooltipsFetchers = toTooltipsFetchers(tooltipsApi);
export const GuidanceFetchers = toGuidanceFetchers(guidanceApi);
export const ModerationFetchers = toModerationFetchers(engageApi);
export const ProgressTrackingFetchers = toProgressTrackingFetchers(progressTrackingApi);
export const PartnershipFetchers = toPartnershipFetchers(engageApi);
export const UserPreferencesFetchers = toUserPreferencesFetchers(userPreferencesApi);

/* --- GraphQL Fethchers */
export const ActivityFeedFetchersGQL = toActivityFeedFetchersGQL(graphQlApi);
export const ProgramsFetchersGQL = toProgramsFetchersGQL(graphQlApi);
export const StackedClassesFetchersGQL = toStackedClassesFetchersGQL(graphQlApi);
export const TagsFetchersGQL = toTagsFetchersGQL(graphQlApi);
export const ScheduledClassFetchersGQL = toScheduledClassFetchersGQL(graphQlApi);
